export default __webpack_public_path__ + "static/media/sponsor.6bd9d9e2.png";